var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11014",
    "data-name": "Group 11014",
    transform: "translate(-124 -390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10994",
    "data-name": "Group 10994",
    transform: "translate(1 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Google_Pay__GPay__Logo__2018-2020_",
    "data-name": "Google_Pay_(GPay)_Logo_(2018-2020)",
    transform: "translate(134.461 400.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10048",
    "data-name": "Path 10048",
    d: "M82.323,61.186A12.808,12.808,0,0,0,82.137,59H72v4.14h5.806a4.976,4.976,0,0,1-2.147,3.267v2.687h3.465A10.512,10.512,0,0,0,82.323,61.186Z",
    transform: "translate(-61.248 -50.195)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10049",
    "data-name": "Path 10049",
    d: "M17.274,94.472A10.288,10.288,0,0,0,24.4,91.877L20.934,89.19a6.52,6.52,0,0,1-9.694-3.41H7.67v2.77A10.75,10.75,0,0,0,17.274,94.472Z",
    transform: "translate(-6.522 -72.977)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10050",
    "data-name": "Path 10050",
    d: "M4.718,46.554a6.441,6.441,0,0,1,0-4.115V39.67H1.148a10.75,10.75,0,0,0,0,9.654Z",
    transform: "translate(0 -33.751)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M17.276,4.251A5.836,5.836,0,0,1,21.4,5.863h0L24.467,2.8A10.329,10.329,0,0,0,17.276,0a10.749,10.749,0,0,0-9.6,5.922l3.57,2.77A6.43,6.43,0,0,1,17.276,4.251Z",
    transform: "translate(-6.523 0)",
    fill: "#ea4335"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6e777083d7b5a34addc0fb94e7ac123e.svg";
export { ForwardRef as ReactComponent };